<template>
  <v-menu
    v-model="menu"
    offset-y
    :max-width="220"
    :max-height="400"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <!--class="hidden-sm-and-down"-->
      <v-btn
        icon
        color="accent"
        v-on="on"
      >
        <avatar
          :size="40"
          :font="18"
          :image-url="getAuthUser.photoURL"
          :display-name="getAuthUser.displayName"
        />
      </v-btn>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ getAuthUser.displayName }}</v-list-item-title>
            <v-list-item-subtitle>{{ getAuthUser.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list
        dense
        class="pt-0"
      >
        <v-list-item :to="{ name: 'profile' }">
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="tenants.length > 1">
          <v-divider />

          <v-list-item :disabled="true">
            <v-list-item-content>
              <v-list-item-title>Organizations</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-for="(tenant, index) in tenants">
            <v-list-item
              :key="`tenant_${index}`"
              :class="{ 'primary--text': isSessionTenant(tenant.id) }"
              :inactive="false"
              @click="onClickTenant(tenant.id)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ tenant.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>


        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Help Center</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider />


        <v-list-item @click="logout">
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script>
import { mapGetters } from 'vuex'
import Avatar from '@/components/Avatar.vue'

export default {
  components: {
    Avatar
  },
  data() {
    return {
      menu: false
    }
  },
  computed: {
    ...mapGetters([
      'getMyTenants',
      'isSessionTenant',
      'getAuthUser'
    ]),
    tenants() {
      const tenants = this.getMyTenants

      return Array.isArray(tenants)
        ? tenants
        : []
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    onClickTenant(tenantId) {
      this.$store.dispatch('changeSession', tenantId)
    }
  },
}
</script>
